import styled from "styled-components";
import GlobalStyle from "./components/GlobalStyles";
import LandingPage from "./components/LandingPage";
import OnePage from "./pages/OnePage";
import arrowUp from "./img/arrow-up.svg";
import React from "react";
import { Link } from "react-scroll";

import "./index.css";
function App() {
  const [showTopBtn, setShowTopBtn] = React.useState(false);
  React.useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);

  return (
    <div className="App" id="app">
      <GlobalStyle />

      {showTopBtn && (
        <Link to="app" smooth={true} duration={1000}>
          <StyledBtn id="button-scroll">
            <img src={arrowUp} alt="strzalka wskazujaca do góry" />
          </StyledBtn>
        </Link>
      )}
      <div className="noise"></div>
      <OnePage />
    </div>
  );
}

export default App;

const StyledBtn = styled.button`
  position: fixed;
  bottom: 3%;
  right: 3%;
  width: 50px;
  height: 50px;
  z-index: 9999999;
  border: none;
  border-radius: 50%;
  background: #483A37;
  border: 1px solid white;
  cursor: pointer;
`;


